var exports = {
  "h": "negative-margin__k13vE2",
};

module.exports = exports;
